/**
 * Shared Dialog/Drawer anatomy (DESIGN.md §5). Every section uses the same inner edge `--space-panel` (20px phones,
 * 24px ≥640px) so the title, body content and footer buttons line up; the footer keeps that padding on all four
 * sides (plus the home-indicator inset) and spaces its actions 12px apart. Phones: footer actions share the row.
 */
export const panel = {
  header: 'flex shrink-0 items-start justify-between gap-4 border-b border-line px-(--space-panel) pt-5 pb-4 sm:pt-6 sm:pb-5',
  close:
    '-mt-1.5 -mr-2 inline-flex size-9 shrink-0 items-center justify-center rounded-md text-subtle transition-colors hover:bg-surface-2 hover:text-ink disabled:opacity-50 max-sm:size-11 max-sm:-mt-2.5 max-sm:-mr-3',
  body: 'min-h-0 flex-1 overflow-y-auto overscroll-contain px-(--space-panel) py-5 sm:py-6',
  footer:
    'safe-bottom flex min-h-[4.5rem] shrink-0 flex-wrap items-center justify-end gap-3 border-t border-line bg-surface-2 px-(--space-panel) pt-4 [--safe-pb:1rem] max-sm:[&>*]:flex-[1_1_auto]',
};
